import Api from "@/services/Api";

export default {
	async all() {
		return Api().get("/tls/pros", {
			params: { limit: 100, group_id: process.env.VUE_APP_TLS_SERVICE_GROUP_ID }
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async find(proId) {
		return Api().get(`/tls/pros/${proId}`, {
			params: { group_id: process.env.VUE_APP_TLS_SERVICE_GROUP_ID }
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	}
};